import { render, staticRenderFns } from "./videoPlayr.vue?vue&type=template&id=1220463f&scoped=true&"
import script from "./videoPlayr.vue?vue&type=script&lang=js&"
export * from "./videoPlayr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220463f",
  null
  
)

export default component.exports